const loadFavorite = (id ?: string) =>{
    if(id) {
        let favorites_str = localStorage.getItem('favorites');
        if(favorites_str != null) {
            const favorites_str = localStorage.getItem('favorites');
            let favorites_json = favorites_str ? JSON.parse(favorites_str) : [];

            let favorites_filter = favorites_json.filter((element: { id: string; }) => (element.id === id));
            if(favorites_filter.length > 0) {
                return true;
            }
        }
    }
    return false;
};

export {loadFavorite};